import { getProductType, ProductEnum } from "../../constants/login";

/** Golf and Spa share the same Excel Review page — one worksheet per import row. */
export const SHEET_BY_SHEET_PRODUCTS = new Set<ProductEnum>([
  ProductEnum.GOLF,
  ProductEnum.SPA,
]);

export type ExcelReviewMode = "settings-groups" | "sheet-by-sheet";

export const getExcelReviewMode = (productId: number): ExcelReviewMode => {
  const product = getProductType(productId) as ProductEnum | undefined;
  return product && SHEET_BY_SHEET_PRODUCTS.has(product)
    ? "sheet-by-sheet"
    : "settings-groups";
};

/** Products that use the Excel Review modal (Versa groups or Golf/Spa sheets). */
export const usesExcelReview = (productId: number): boolean => {
  const product = getProductType(productId) as ProductEnum | undefined;
  if (!product) return false;
  return (
    product === ProductEnum.VERSA ||
    product === ProductEnum.TEST ||
    SHEET_BY_SHEET_PRODUCTS.has(product)
  );
};
